import { Dialog } from "primereact/dialog";
import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Login from "pages2/Login";
import Register from "pages2/Register";
import PasswordResetOptions from "pages2/PasswordResetOptions";
import SendPasswordResetLink from "pages2/SendPasswordResetLink";
import ResetPassword from "pages2/ResetPassword";
import { getAuthMode, withoutAuthUrl } from "utils/authModal";
import "./AuthModal.css";

const screens = {
	login: { component: Login, title: "Login to your account" },
	register: { component: Register, title: "Create an account" },
	"password-reset": { component: PasswordResetOptions, title: "Reset password" },
	"send-reset-link": { component: SendPasswordResetLink, title: "Send password reset link" },
	"reset-password": { component: ResetPassword, title: "Reset password" },
};

const AuthModal = () => {
	const location = useLocation();
	const history = useHistory();
	const mode = getAuthMode(location);
	const visible = Boolean(mode);
	const returnFocusRef = useRef(null);
	const contentRef = useRef(null);
	const screen = screens[mode];
	const Component = screen?.component;

	useEffect(() => {
		if (!visible) return;
		returnFocusRef.current = document.activeElement;
		return () => {
			if (returnFocusRef.current?.isConnected) returnFocusRef.current.focus({ preventScroll: true });
		};
	}, [visible]);

	useEffect(() => {
		if (visible) {
			contentRef.current?.focus();
			contentRef.current?.closest(".p-dialog-content")?.scrollTo?.(0, 0);
		}
	}, [mode, visible]);

	return (
		<Dialog
			visible={visible}
			onHide={() => history.replace(withoutAuthUrl(location))}
			header={<span className="sr-only">{screen?.title}</span>}
			modal
			blockScroll
			draggable={false}
			resizable={false}
			dismissableMask
			closeOnEscape
			focusOnShow={false}
			onShow={() => contentRef.current?.focus()}
			ariaCloseIconLabel="Close authentication"
			maskClassName="auth-dialog-mask"
			className={`auth-dialog ${mode === "register" ? "auth-dialog--register" : ""}`}
		>
			{Component && (
				<div key={mode} ref={contentRef} tabIndex={-1} className="auth-dialog__screen">
					<Component />
				</div>
			)}
		</Dialog>
	);
};

export default AuthModal;
